import { render, staticRenderFns } from "./workspace-library-data-view.vue?vue&type=template&id=dede75d0"
import script from "./workspace-library-data-view.vue?vue&type=script&lang=js"
export * from "./workspace-library-data-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports